/**
 * amel — 商品ページ（スマホ）サムネイル一覧 / 検証用
 * ---------------------------------------------------------------------------
 * 既存のスライド（Flickity）の下に、全画像のサムネイル一覧を作ります。
 *  ・サムネイルをタップすると、メイン画像がその画像に切り替わります。
 *  ・左右の矢印は、テーマ既存のものをそのまま使います。
 *  ・商品データ・画像・並び順は書き換えません（表示用のDOMを足すだけ）。
 * 一覧は CSS により PC（1008px以上）では非表示です。
 * 失敗した場合も、既存のスライド表示はそのまま動きます。
 */
(function () {
  function thumbUrl(url, w) {
    // https://cdn.shopify.com/.../file.jpg?v=123 → .../file_240x.jpg?v=123
    return url.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_' + w + 'x$1$2');
  }

  function setup() {
    var root = document.querySelector('.Product[data-section-type="product"]');
    if (!root || root.getAttribute('data-amel-thumbs-ready')) return;

    var gallery = root.querySelector('.Product__Gallery');
    var slideshow = gallery && gallery.querySelector('.Product__Slideshow');
    if (!gallery || !slideshow) return;

    // Flickity が .flickity-slider で包むため、直下ではなく子孫から取得する
    var items = Array.prototype.slice.call(
      slideshow.querySelectorAll('.Product__SlideItem')
    );
    if (items.length < 2) return;

    root.setAttribute('data-amel-thumbs-ready', 'true');

    var grid = document.createElement('div');
    grid.className = 'amel-thumbs__grid';
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', '商品画像の一覧');

    var buttons = items.map(function (item, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'amel-thumbs__item';
      btn.setAttribute('aria-label', (i + 1) + ' / ' + items.length + ' 枚目を表示');

      var src = item.querySelector('img[data-original-src]');
      if (src && src.getAttribute('data-original-src')) {
        var t = document.createElement('img');
        t.src = thumbUrl(src.getAttribute('data-original-src'), 240);
        t.alt = '';
        t.loading = 'lazy';
        t.decoding = 'async';
        btn.appendChild(t);
      } else {
        var m = document.createElement('span');
        m.className = 'amel-thumbs__mark';
        m.textContent = '▶';
        btn.appendChild(m);
      }

      btn.addEventListener('click', function () { goTo(i); });
      grid.appendChild(btn);
      return btn;
    });

    // 矢印ナビの直後（なければスライドの直後）に置く
    var anchor = gallery.querySelector('.Product__SlideshowMobileNav') || slideshow;
    anchor.parentNode.insertBefore(grid, anchor.nextSibling);

    function selectedIndex() {
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-selected')) return i;
      }
      return 0;
    }

    function sync() {
      var cur = selectedIndex();
      buttons.forEach(function (b, i) {
        var on = i === cur;
        b.classList.toggle('is-active', on);
        if (on) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    }

    function goTo(i) {
      var f = window.Flickity && window.Flickity.data && window.Flickity.data(slideshow);
      if (f && typeof f.select === 'function') {
        f.select(i);
      } else {
        var dot = gallery.querySelector('.flickity-page-dots .dot[data-index="' + i + '"]');
        if (dot) dot.click();
      }
      // メイン画像が画面の上に隠れている場合は、見える位置まで戻す
      var rect = slideshow.getBoundingClientRect();
      if (rect.top < 60) {
        window.scrollTo({ top: rect.top + window.pageYOffset - 70, behavior: 'smooth' });
      }
      window.setTimeout(sync, 0);
    }

    // スライドの選択状態（is-selected）が変わったら、サムネイルの強調を合わせる
    if (window.MutationObserver) {
      var mo = new MutationObserver(sync);
      items.forEach(function (it) {
        mo.observe(it, { attributes: true, attributeFilter: ['class'] });
      });
    }
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
